import './breakpoints.css';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { mediaMobile } from './breakpoints';

export type TextVariant =
  | 'body-1'
  | 'body-2'
  | 'body-3'
  | 'body-4'
  | 'body-5'
  | 'body-6'
  | 'body-7'
  | 'sub-h1'
  | 'sub-h2'
  | 'sub-h3'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6';

export interface Props {
  variant?: TextVariant;
  bold?: boolean;
  block?: boolean;
}

const makeVariant = (variant: TextVariant) => css`
  font-family: var(--${variant}-font-family);
  font-weight: var(--${variant}-font-weight);
  font-size: var(--${variant}-font-size-desktop, --${variant}-font-size);
  line-height: var(--${variant}-line-height-desktop, --${variant}-line-height);
  letter-spacing: var(--${variant}-spacing, inherit);
  text-transform: var(--${variant}-transform, inherit);

  ${mediaMobile} {
    font-size: var(--${variant}-font-size);
    line-height: var(--${variant}-line-height);
  }

  .mobileOnly & {
    font-size: var(--${variant}-font-size);
    line-height: var(--${variant}-line-height);
  }
`;

export const Text = styled.span<Props>`
  ${props => makeVariant(props.variant ?? 'body-5')}

  display: ${props => (props.block ? 'block' : 'inherit')};

  ${props =>
    props.bold
      ? css`
          font-family: var(
            --${props.variant}-font-family-bold,
            --${props.variant}-font-family
          );
        `
      : ''}
`;
